import { generatePaginationPageNumbers } from "@/utils/category";
import React from "react";

const Pagination = ({ currentPage, pageCount, onPageChange, t, device }) => {
    if (pageCount <= 1) return null;

    const handlePageClick = (page) => {
        if (page >= 1 && page <= pageCount) {
            onPageChange(page);
        }
    };

    const pageNumbers = generatePaginationPageNumbers(
        currentPage,
        pageCount,
        device === "mobile" ? 3 : 6
    );

    return (
        <div className="flex justify-center items-center gap-2 text-sm md:text-lg text-gray-700">
            {/* Previous Button */}
            <button
                className="px-2.5 py-1.5 rounded-lg transition-all duration-200 bg-gray-200 hover:bg-gray-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Previous page"
            >
                {t("Prev")}
            </button>

            {/* Page Numbers */}
            {pageNumbers.map((page, index) =>
                page === "..." ? (
                    <span key={index} className="p-1 text-lightblue">
                        ...
                    </span>
                ) : (
                    <button
                        key={index}
                        className={`px-2.5 py-1.5 rounded-lg transition-all duration-200 ${
                            currentPage === page
                                ? "bg-blue campaign:bg-campaignAccent text-white font-semibold shadow-md"
                                : " bg-gray-100 hover:bg-gray-200"
                        }`}
                        onClick={() => handlePageClick(page)}
                        aria-label={`Go to page ${page}`}
                    >
                        {page}
                    </button>
                )
            )}

            {/* Next Button */}
            <button
                className="px-2.5 py-1.5 rounded-lg transition-all duration-200 bg-gray-200 hover:bg-gray-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === pageCount}
                aria-label="Next page"
            >
                {t("Next")}
            </button>
        </div>
    );
};

export default Pagination;
